/* ====== 業者名検索 ===== */
const searchInput = document.querySelector('.search__input input');
const searchResult = document.querySelector('.search__result');
const searchItems = document.querySelectorAll('.search__item');

const searchTotal = document.querySelector('.search__total');
if (searchTotal) {
  searchTotal.textContent = `掲載数 ${searchItems.length} 件`;
}

if (searchInput) {
  searchResult.style.display = 'none';
  const searchAttention = document.querySelector('.search__attention');
  if (searchAttention) searchAttention.style.display = 'none';

  const toKatakana = (str) =>
    str.replace(/[\u3041-\u3096]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) + 0x60));

  const hasKanji = (str) => /[\u4E00-\u9FFF\u3400-\u4DBF]/.test(str);

  searchInput.addEventListener('input', () => {
    const raw = searchInput.value.trim();
    const query = toKatakana(raw);

    if (searchAttention) {
      searchAttention.style.display = hasKanji(raw) ? '' : 'none';
    }
    let count = 0;

    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const queryReg = query !== '' ? new RegExp(`(${escapedQuery})`, 'g') : null;

    searchItems.forEach((item) => {
      const nameEl = item.querySelector('.search__name');
      const telEl = item.querySelector('.search__tel');
      const name = nameEl.textContent;
      const tel = telEl ? telEl.textContent : '';
      const match = query === '' || name.includes(query) || tel.includes(query);
      item.style.display = match ? '' : 'none';
      if (match && queryReg) {
        count++;
        nameEl.innerHTML = name.replace(queryReg, '<mark>$1</mark>');
        if (telEl) telEl.innerHTML = tel.replace(queryReg, '<mark>$1</mark>');
      } else {
        nameEl.textContent = name;
        if (telEl) telEl.textContent = tel;
        if (match) count++;
      }
    });

    if (query === '') {
      searchResult.style.display = 'none';
    } else {
      searchResult.style.display = '';
      searchResult.childNodes[0].textContent = `検索結果 ${count} 件 `;
      const noneEl = searchResult.querySelector('.none');
      if (noneEl) noneEl.style.display = count === 0 ? '' : 'none';
    }
  });
}

/* ====== headerにクラス付与 ===== */
const header = document.querySelector('.header');
const fv = document.querySelector('.fv');

if (fv) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      header.classList.toggle('is-active', !entry.isIntersecting);
    }
  );

  observer.observe(fv);
}
